module.exports = __webpack_public_path__ + "img/Icon-tree-user-edits.fc3e92c6.svg";